// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IPublicSuburbanV1GetOffersHistorySpoilerRequest,
  TPublicSuburbanV1GetOffersHistorySpoilerModel,
  IMappers,
  TPublicSuburbanV1GetOffersHistorySpoilerResponse,
  IPublicSuburbanV1GetOffersHistorySpoilerResponse,
  IPublicSuburbanV1GetOffersHistorySpoilerResponseError,
} from './types';

export const defaultConfig: TPublicSuburbanV1GetOffersHistorySpoilerModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'valuation-offer-history',
  pathApi: '/suburban/v1/get-offers-history-spoiler/',
} as TPublicSuburbanV1GetOffersHistorySpoilerModel;

export function createPublicSuburbanV1GetOffersHistorySpoilerModel(
  parameters: IPublicSuburbanV1GetOffersHistorySpoilerRequest,
): TPublicSuburbanV1GetOffersHistorySpoilerModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicSuburbanV1GetOffersHistorySpoilerOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicSuburbanV1GetOffersHistorySpoilerRequest;
}

export async function fetchPublicSuburbanV1GetOffersHistorySpoiler<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicSuburbanV1GetOffersHistorySpoilerOptions<TResponse200, TResponse400>): Promise<
  TPublicSuburbanV1GetOffersHistorySpoilerResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createPublicSuburbanV1GetOffersHistorySpoilerModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicSuburbanV1GetOffersHistorySpoilerResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IPublicSuburbanV1GetOffersHistorySpoilerResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicSuburbanV1GetOffersHistorySpoilerResponse;
}
